import { AbstractModel } from "@uzurv/core"
import { autoserialize, inheritSerialization } from "cerialize"

@inheritSerialization(AbstractModel)
export class NotificationType extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;
}
